/**
 * Screen Wake Lock helper — keeps the device awake during recording.
 * Delegates to platform module for native (KeepAwake) vs web (Wake Lock API).
 */

import { requestWakeLock as platformRequestWakeLock } from '../platform/wake-lock';

let activeLock: { release: () => Promise<void> | void } | null = null;

export async function requestWakeLock(): Promise<WakeLockSentinel | null> {
  const handle = await platformRequestWakeLock();
  activeLock = handle;
  return handle as unknown as WakeLockSentinel | null;
}

export async function releaseWakeLock(lock?: WakeLockSentinel | null): Promise<void> {
  const target = lock ?? activeLock;
  if (!target) return;
  try {
    await (target as any).release?.();
  } catch {
    // Already released — ignore
  }
  if (activeLock === target) activeLock = null;
}
